module.exports = "https://cdn.dove.it/_next/static/public/assets/channels/logo-wikicasa.5d630a45d95f3b87e9f3aa47bf3decb7.png";